<template>
  <div class="banner-cover">
    <div class="banner">
      <img 
        src="@/assets/icons/subscription-close-modal.svg" 
        class="close-btn" 
        alt="Close" 
        @click="closeBanner()" :class="activeClose ? 'active' : ''"
      >
      <div class="inner-banner-image">
        <img src="../assets/images/subscription-modal.png" alt="img"/>
      </div>
      <div class="banner-content">
        <img src="@/assets/main_logo.svg" alt="Kidjo TV" class="logo">
        <div class="main-title">
          {{ strings.bannerTitle }}
        </div>
        <div class="title">
          {{ getBillingInformation() }}
        </div>
        <div class="info">
          {{ strings.bannerSubTitleInfo }}
        </div>
        <div class="buttons-wrapper">
          <button
            class="register-btn"
            v-if="getUserName"
            @click="goToChangePlan"
          >
            <span class="register-btn-label">
              {{ strings.register }}
            </span>
            <img
              src="@/assets/icons/register_arrow_right.svg?url"
              alt="arrow Icon"
            />
          </button>

          <button
            v-if="!getUserName"
            class="register-btn"
            @click="goToAccount('/register')"
          >
            <span class="register-btn-label">
              {{ strings.register }}
            </span>
            <img
              src="@/assets/icons/register_arrow_right.svg?url"
              alt="arrow Icon"
            />
          </button>

          <button
            v-if="!getUserName"
            class="login-btn"
            @click="goToAccount('/login')"
          >
            <span class="login-btn-label">
              {{ strings.login }}
            </span>
            <img
              src="@/assets/icons/login_arrow_right.svg?url"
              alt="arrow Icon"
            />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import langUtil, { StringKey } from '@/utils/lang.util';
  import { soundList, soundPlayer } from '@/utils/sounds';

  export default {
    data() {
      return {
        activeClose: false,
        activeStart: false,
        euCountries: ['BE', 'EL', 'LT', 'PT', 'BG', 'ES', 'LU', 'RO', 'CZ', 'FR', 'HU', 'SI', 'DK', 'HR', 'MT', 'SK', 'DE', 'IT', 'NL', 'FI', 'EE', 'CY', 'AT', 'SE', 'IE', 'LV', 'PL'],
        price: '4.99$',
        strings: {
          bannerTitle: langUtil.getLang().t(StringKey.BannerSubTitle),
          bannerSubTitleMonth: langUtil.getLang().t(StringKey.BannerSubTitleMonth),
          bannerSubTitleInfo: langUtil.getLang().t(StringKey.BannerSubInfo),
          register: langUtil.getLang().t(StringKey.SettingsRegister),
          login: langUtil.getLang().t(StringKey.SettingsToLogin)
        },
      };
    },

    methods: {
      setBannerState(set) {
        this.$store.dispatch('settings/setBannerState', set);
      },

      handleKeyboard(event) {
        event.preventDefault();
        try {
          switch (event.keyCode) {
            case VK_DOWN: {
              if (this.activeStart) {
                this.activeStart = false;
                this.activeClose = true;
              } else if (this.activeClose) {
                this.activeClose = false;
                this.activeStart = true;
              }

              break;
            }
            case VK_UP: {
              if (this.activeStart) {
                this.activeStart = false;
                this.activeClose = true;
              } else if (this.activeClose) {
                this.activeClose = false;
                this.activeStart = true;
              }

              break;
            }

            case VK_ENTER: {
              if (this.activeStart) {
                this.goToAccount('/register');
              } else if (this.activeClose) {
                this.closeBanner();
              }

              break;
            }
          }
        } catch (error) {
          switch (event.code) {
            case 'ArrowDown': {
              if (this.activeStart) {
                this.activeStart = false;
                this.activeClose = true;
              } else if (this.activeClose) {
                this.activeClose = false;
                this.activeStart = true;
              }

              break;
            }
            case 'ArrowUp': {
              if (this.activeStart) {
                this.activeStart = false;
                this.activeClose = true;
              } else if (this.activeClose) {
                this.activeClose = false;
                this.activeStart = true;
              }

              break;
            }
            case 'Enter': {
              if (this.activeStart) {
                this.goToAccount('/register');
              } else if (this.activeClose) {
                this.closeBanner();
              }

              break;
            }
          }
        }
      },

      setCurrency() {
        const cc = localStorage.getItem('kdj_cc') || 'US';
        if (cc === 'CH') {
          this.price = '6.90CHF';
        } else if (this.euCountries.includes(cc)) {
          this.price = '4,99€';
        }
      },

      goToAccount(ulr) {
        soundPlayer(soundList.general);
        const params = new URLSearchParams(window.location.search);
        let addOn = '?app=tv';

        if (params.has('vewd')) {
          const key = this.$route.params.identifier;
          addOn = '?tv-app-folder=' + key;
        }
        window.location.href = process.env.VUE_APP_ACCOUNT_BASE_URL + ulr + addOn;
      },

      getUserGenerateKey() {
        return this.$store.dispatch('account/getUserGenerateKey');
      },

      async goToChangePlan () {
        soundPlayer(soundList.general);
        await this.getUserGenerateKey().then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('account/resetUserToken');
            console.log('response', response);
            window.location.href =
              process.env.VUE_APP_ACCOUNT_BASE_URL + 
              '/changePlan' + 
              '?app=tv' + 
              '&key=' + response.data.redirectKey;
          }
        }).catch((error) => {
          console.log(error);
        })
      },

      closeBanner() {
        soundPlayer(soundList.general);
        this.setBannerState(false);
        this.$emit('closeBanner');
      },

      getBillingInformation(){
        return this.strings.bannerSubTitleMonth.split('%')[0] + this.price + this.strings.bannerSubTitleMonth.split('$s')[1];
      }
    },

    mounted() {
      // Set the currency by country code
      this.setCurrency();
      this.activeStart = true;

      document.addEventListener('keyup', this.handleKeyboard);
    },

    computed: {
      getUserName() {
        return this.$store.getters["account/getUserName"];
      },
    },

    destroyed() {
      document.removeEventListener('keyup', this.handleKeyboard);
    },
  };
</script>

<style lang="scss">
  .banner-cover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1010;

    .banner {
      background-color: white;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      width: 80%;
      max-width: 980px;
      margin: auto;
      border-radius: 15px;
      position: relative;
      display: flex;
      overflow: hidden;
      max-height: 98%;

      @media (max-width: 768px) {
        flex-direction: column;
        max-width: 350px;
        width: 85%;
      }

      @media (orientation: landscape) and (max-height: 480px) {
        flex-direction: row;
        max-width: 640px;
        width: 74%;
        height: 90%;
      }

      @media (min-width: 1024px) {
        width: 50%;
        height: 56%;
      }

      @media (min-width: 1280px) {
        width: 55%;
        height: 66%;
      }

      @media (min-width: 1536px) {
        width: 50%;
        height: 60%;
      }

      .close-btn {
        position: absolute;
        top: 2%;
        left: 1.4%;
        width: 41px;
        height: 40px;
        cursor: pointer;

        &.active {
          transform: scale(1.1);
        }

        @media (max-width: 768px) {
          top: 8px;
          left: 8px;
          transform: scale(0.9);
        }

        &:hover,
        &focus {
          transform: scale(1.1);
        }
      }

      .inner-banner-image {
        width: 55%;
        padding: 3px;

        @media (max-width: 768px) {
          width: 100%;
          height: 50%;
        }

        @media (orientation: landscape) and (max-height: 480px) {
          width: 55%;
          margin-top: 0px;
          height: unset;
        }

        @media (max-height: 300px) {
          width: 50%;
        }

        img{
          width: 100%;
          height: 100%;
          border-top-left-radius: 13px;
          border-bottom-left-radius: 13px;

          @media (max-width: 768px) {
            width: calc(100% - 6px);
            border-top-right-radius: 13px;
            border-bottom-left-radius: 0;  
          }        
        }
      }

      .banner-content {
        padding: 30px;
        width: 45%;
        text-align: left;
        display: flex;
        flex-direction: column;
        gap: 10px;

        @media (max-width: 768px) {
          align-items: flex-start;
          width: 100%;
          height: 50%;
          text-align: center;
          margin-left: 0;
          gap: 2px;
          padding: 10px;
        }

        @media (orientation: landscape) and (max-height: 480px) {
          justify-content: space-around;
          height: unset;
          text-align: left;
          margin-left: 0;
          padding: 15px;
          padding-inline: 10px;
          width: 50%;
          gap: 2px;
        }

        @media (max-height: 300px) {
          padding-block: 5px;
          padding-inline: 10px;
          width: 50%;
          gap: 0px;
        }

        @media (min-width: 1024px) {
          justify-content: center;
          gap: 2px;
        }

        @media (min-width: 1280px) {
          justify-content: center;
        }

        @media (min-width: 1536px) {
          justify-content: center;
        }

        .logo {
          width: 80px;
          height: 49px;
          display: block;
          transform: scale(1.3);
          padding-left: 12px;
          margin-bottom: 15px;

          @media (max-width: 768px) {
            padding-left: 10px;
            padding-block: 5px;
          }

          @media (min-width: 280px) and (max-width: 390px){
            margin-bottom: 5px;
          }

          @media (orientation: landscape) and (max-height: 480px) {
            transform: scale(0.9);
            padding: 0px;
            padding-block: 0px;
            margin-bottom: 0px;
          }

          @media (orientation: landscape) and (max-height: 540px) {
            width: 60px;
            margin-bottom: 0px;
          }

          @media (max-height: 300px) {
            transform: scale(1);
          }
        }

        .main-title {
          display: block;
          font-family: 'Nunito-ExtraBold';
          font-size: 20px;
          color: #29b6f6;

          @media (max-width: 768px) {
            font-size: 24px;
            padding: 0;
          }

          @media (orientation: landscape) and (max-height: 480px) {
            font-size: 24px;
            padding: 0;
          }

          @media (orientation: landscape) and (max-height: 540px) {
            font-size: 22px;
          }

          @media (max-height: 300px) {
            font-size: 13px;
          }
          @media (min-width: 1536px) {
            font-size: 26px;
            padding: 0;
          }
        }

        .title {
          display: block;
          font-family: 'Nunito-Regular';
          font-size: 20px;
          color: #29b6f6;

          @media (max-width: 768px) {
            font-size: 24px;
            padding: 0;
          }

          @media (orientation: landscape) and (max-height: 480px) {
            font-size: 22px;
            padding: 0;
          }

          @media (orientation: landscape) and (max-height: 540px) {
            font-size: 18px;
          }

          @media (max-height: 300px) {
            font-size: 13px;
          }

          @media (min-width: 1536px) {
            font-size: 26px;
            padding: 0;
          }
        }

        .info {
          display: block;
          font-family: 'Nunito-Regular';
          font-size: 12px;
          color: #29b6f6;
          margin-bottom: 15px;
          opacity: 0.9;
          margin-block: 20px;

          @media (max-width: 768px) {
            font-size: 12px;
            margin-block: 10px;
            text-align: left;
          }

          @media (orientation: landscape) and (max-height: 480px) {
            font-size: 12px;
            margin-block: 0px;
            margin-bottom: 5px;
          }

          @media (orientation: landscape) and (max-height: 540px) {
            margin-block: 5px;
          }

          @media (max-height: 300px) {
            font-size: 10px;
          }

          @media (min-width: 1280px) {
            font-size: 14px;
          }

          @media (min-width: 1536px) {
            font-size: 18px;
            padding: 0;
          }
        }

        .buttons-wrapper{
          width: 75%;
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding-bottom: 10px;

          .register-btn {
            width: 100%;
            padding: 10px;
            background: #29b6f6;
            border: 2px solid #29b6f6;
            border-radius: 10px;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .register-btn-label {
              font-size: 18px;
              font-family: 'Nunito-ExtraBold';
              float: left;
            }

            img {
              transform: scale(1.2);
            }
            
            @media (max-width: 840px) {
              font-size: 16px;
            }
    
            @media (max-width: 768px) {
              font-size: 18px;
            }
    
            @media (orientation: landscape) and (max-height: 480px) {
              line-height: 0.6;
              padding-left: 10px;

              .register-btn-label {
                font-size: 16px;
              }
            }

            @media (max-height: 300px) {
              line-height: 0.6;

              .register-btn-label {
                font-size: 14px;
              }
            }
    
            &.active {
              animation: pulse_button 1.5s infinite;
            }

            &:hover,
            &:focus {
              animation: pulse_button 1.5s infinite;
    
              @keyframes pulse_button {
                0% {
                  transform: scale(0.95);
                  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
                }
                70% {
                  transform: scale(1);
                  box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
                }
                100% {
                  transform: scale(0.95);
                  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                }
              }
            }
          }

          .login-btn {
            width: 100%;
            padding: 10px;
            background: #fff;
            border: 2px solid #29b6f6;
            border-radius: 10px;
            color: #29b6f6;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
    
            .login-btn-label {
              font-size: 18px;
              font-family: 'Nunito-ExtraBold';
              float: left;
            }

            img {
              transform: scale(1.2);
            }

            @media (max-width: 840px) {
              font-size: 16px;
            }
    
            @media (max-width: 768px) {
              font-size: 18px;
            }
    
            @media (orientation: landscape) and (max-height: 480px) {
              line-height: 0.6;
              padding-left: 10px;

              .login-btn-label {
                font-size: 16px;
              }
            }
    
            @media (max-height: 300px) {
              line-height: 0.6;

              .login-btn-label {
                font-size: 14px;
              }
            }
    
            &.active {
              animation: pulse_button 1.5s infinite;
            }

            &:hover,
            &:focus {
              animation: pulse_button 1.5s infinite;
    
              @keyframes pulse_button {
                0% {
                  transform: scale(0.95);
                  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
                }
                70% {
                  transform: scale(1);
                  box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
                }
                100% {
                  transform: scale(0.95);
                  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                }
              }
            }
          }
        }
      }
    }
  }
</style>
